import type { Dispatch } from 'redux';
import { Form, FormRenderProps } from 'react-final-form';
import { connect, useDispatch } from 'react-redux';
import { useCallback } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { ISimilarityStatusEnum } from 'APIPackage/SimilarityModule/interfaces/ISimilarityStatus';
import { ISimilaritiesFilter } from 'APIPackage/SimilarityModule/interfaces/ISimilaritiesFilter';
import { SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { Row } from 'UIPackage/FormModule/components/Row';

import styles from './SimilaritiesDateModal.module.scss';
import { getSimilaritiesFilter } from '../selectors/similaritiesSelectors';
import { similaritiesChangeStatus } from '../actions/similaritiesActions';

interface ITemplateFiltersModalProps {
  isVisible?: boolean;
  onClose: () => void;
  startDateOptions: ISelectOption[];
  similarityId: string;
  filter: ISimilaritiesFilter;
}

interface IFiltersModalForm {
  startDate: ISelectOption;
}

const SimilaritiesDateModalWithoutStore = ({
  isVisible,
  onClose,
  startDateOptions,
  similarityId,
  filter,
}: ITemplateFiltersModalProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const onSubmit = useCallback(
    (data: IFiltersModalForm) => {
      const { startDate } = data;
      const startingDate: string = formatDate({ date: startDate.value, dateFormat: SYSTEM_DATE_FORMAT_FNS });

      dispatch(similaritiesChangeStatus(ISimilarityStatusEnum.JOINTLY, similarityId, startingDate, filter));
      onClose();
    },
    [dispatch, filter, onClose, similarityId],
  );

  const renderForm = useCallback(
    ({ handleSubmit }: FormRenderProps<IFiltersModalForm>) => (
      <form onSubmit={handleSubmit}>
        <ModalHeader title="Совмещение" color="black" />
        <ModalBody size="content" border="bottom">
          <Row>
            <FieldBlock label="Выберите дату начала КНМ из списка доступных">
              <SelectInputField name="startDate" options={startDateOptions} />
            </FieldBlock>
          </Row>
        </ModalBody>
        <ModalActions>
          <Button type="submit" color="primary" size="medium" text="Совместить" />
          <Button type="button" onClick={onClose} color="default" size="medium" text="Отменить" />
        </ModalActions>
      </form>
    ),
    [onClose, startDateOptions],
  );

  return (
    <Modal modalBodyClassName={styles.Modal} visible={isVisible} onClose={onClose}>
      <Form<IFiltersModalForm> onSubmit={onSubmit} render={renderForm} />
    </Modal>
  );
};

const mapStateToProps = (state: IRootState) => ({
  filter: getSimilaritiesFilter(state),
});

export const SimilaritiesDateModal = connect(mapStateToProps)(SimilaritiesDateModalWithoutStore);
